// src/pages/Platform.js
import React from "react";
import PlatformLayout from "../components/PlatformLayout";
import PlatformHomeAspirante from "../components/PlatformHomeAspirante";

export default function Platform({ user = null }) {
  return (
    <PlatformHomeAspirante userInfo={user} />
  );
}
